<template>
    <div class="TQ_borderRadius TQ_clickable TQ_box_shadow TQ_border_darkGray" :class="p_checked_b ? 'TQ_bg_purple' : 'TQ_bg_gray3'">

        <img :src="p_checked_b ? ass_img_checked_w : ass_img_checked_gray" class="TQ_width_100p TQ_verticalAlignMiddle TQ_padding_4px TQ_borderBox" />
    </div>
</template>

<script>
    import {ass_img_checked_gray, ass_img_checked_w} from "../../assets/scripts/Ass_Files";

    export default {
        name: "TqCheckbox",
        props:{
            p_checked_b : {
                require: true,
                type: Boolean
            }
        },
        data(){
            return {
                ass_img_checked_w : ass_img_checked_w,
                ass_img_checked_gray : ass_img_checked_gray,

            }
        },

    }
</script>

<style scoped lang="scss">

    .lc_input{
        display: none;
    }

</style>